import React, { useState, useEffect } from 'react';
import { Card, Pagination, Select } from 'antd';
import { Collapse } from 'antd';
import { get_supporting_question_list } from '../../../Redux/Apis/user/ApiConfig';

import './SupportingInformation.css';

const SearchIcon = '/assets/SearchIcon.svg';
const downloadText = '/assets/download-text.svg';
const pdfIcon = '/assets/pdf-icon.png';
const DocumentIcon = '/assets/document-icon.png';

const SupportingInformation = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [list, setList] = useState([]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        fetchQuestionData();

        //gtm
        window.dataLayer.push({
            event: 'FAQ',
            buttonName: 'Supporting Informations',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
    }, []);

    const processListData = (items) => {
        return items.map((item) => {
            return {
                key: item.id,
                label: item.topic_name,
                children: <RenderQuestions menuData={item.questions} />,
            };
        });
    };

    const fetchQuestionData = async () => {
        try {
            const { data } = await get_supporting_question_list();
            setList(processListData(data.data));
        } catch (err) {}
    };

    return (
        <div className='resources-tab-padding'>
            <div className='resources-input-div'>
                {/* <div className='relative search-container'>
                    <input
                        created_by='text'
                        placeholder='Search Documents here...'
                        className='search-from-logs'
                    />
                    <img
                        src={SearchIcon}
                        alt='searchIcon'
                        className='search-icon'
                    />
                </div> */}
                {/* <div>
                    <Select
                        defaultValue='Sort By'
                        className='resouces-select'></Select>
                </div> */}
            </div>

            <div className='resource-info-accordian'>
                <Card className='accordian-main'>
                    <div className='accordian-content '>
                        <h3>FAQ</h3>
                        <div className='resource-custom-scrollbar'>
                            <div>
                                <Collapse
                                    accordion
                                    className='custom-collapse'
                                    items={list}
                                    defaultActiveKey={['1']}></Collapse>
                            </div>
                        </div>
                    </div>
                    {/* <div className="Vertical-line-div"></div>
          <div className="download-document">
            <h3>Download</h3>

            <div className="download-div">
              <img src={pdfIcon} alt="pdfIcon" />
              <h3>PDF File</h3>
            </div>
            <div className="download-div">
              <img src={DocumentIcon} alt="documentIcon" />
              <h3> Document File</h3>
            </div>
            <div className="download-div">
              <img src={downloadText} alt="downloadTextIcon" />
              <h3>Text File</h3>
            </div>
          </div> */}
                </Card>
            </div>

            <div className='resources-pagination'>
                <Pagination
                    current={currentPage}
                    onChange={handlePageChange}
                    total={8}
                    pageSize={10}
                />
            </div>
        </div>
    );
};

const RenderQuestions = ({ menuData }) => {
    return (
        <ul>
            {menuData?.map((menuItem, index) => (
                <React.Fragment key={menuItem.id}>
                    <li>
                        <b>{menuItem.question}</b>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: menuItem.answer,
                            }}
                            className='faq-rendering'
                        />

                        {menuItem.children && (
                            <>
                                <RenderQuestions menuData={menuItem.children} />
                            </>
                        )}
                    </li>

                    {index < menuData?.length - 1 && <hr className='hr-onqa' />}
                </React.Fragment>
            ))}
        </ul>
    );
};

export default SupportingInformation;
